// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3jBQc","gfeWrapper":"CalendarEvent_gfeWrapper__1x4fb"};